type option = {
    id: string;
    text: string;
    isChecked: boolean;
}

export default class MultiSelectInput {
    private readonly element: HTMLElement;
    private readonly hasPostValueChange: boolean;
    private readonly options: option[];
    private readonly label: string;

    constructor(element: HTMLElement) {
        this.element = element;
        this.hasPostValueChange = element.dataset.postValueChange === "true";
        this.options = JSON.parse(element.dataset.options);
        console.log(this.options);
        this.label = element.dataset.label;
    }

    render() {
        this.element.innerHTML = "";
        const html = `
            <div class="p-2">
                <span>${this.label}</span>
                <hr class="m-1"/>
                <div class="ms-1">
                    ${this.options
                        .map((option, i) => {
                            return `
                                <div class="form-check">
                                    <input class="form-check-input" ${option.isChecked && "checked"} type="checkbox" value="${option.id}" id="luscinia-check-${option.text}">
                                    <label class="form-check-label" for="luscinia-check-${option.text}">${option.text}</label>
                                </div>
                            `;
                        })
                        .join("")}
                </div>
            </div>
    `;

        this.element.innerHTML += html;
    }

    private initBootgrid() {
        ($(this.element).find("table") as any)
            .on("selected.rs.jquery.bootgrid", (e: Event, rows: object[]) => {
                if (this.hasPostValueChange) this.postValueChange();
            })
            .on("deselected.rs.jquery.bootgrid", (e: Event, rows: object[]) => {
                if (this.hasPostValueChange) this.postValueChange();
            })
            .bootgrid({
                selection: true,
                multiSelect: true,
                rowSelect: true,
                rowCount: -1,
                navigation: 0,
                isSelectAllCheckboxVisible: false,
            });
    }

    private postValueChange() {
        console.log("post value change");
    }
}
